import { convertFigmaColors } from 'themes/convertFigmaColors';
import figmaColors from 'themes/partners/80lv/json/colors.json';

export const colors = convertFigmaColors(figmaColors);
